import { useTheme, type ThemePreference } from '~/lib/theme.js';
import { cn } from '~/lib/cn.js';

const OPTIONS: { value: ThemePreference; label: string; glyph: string }[] = [
  { value: 'light', label: 'Light', glyph: '☀' },
  { value: 'dark', label: 'Dark', glyph: '☾' },
  { value: 'system', label: 'System', glyph: '◐' },
];

/**
 * A three-state radio group rather than a two-state switch, so "follow the
 * system" stays reachable after someone has made a manual choice.
 */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme();

  return (
    <fieldset className="flex items-center rounded-full border border-line-strong p-0.5">
      <legend className="sr-only">Colour theme</legend>
      {OPTIONS.map((option) => {
        const active = preference === option.value;
        return (
          <label
            key={option.value}
            className={cn(
              'flex size-8 cursor-pointer items-center justify-center rounded-full text-sm transition-colors',
              active ? 'bg-primary text-white dark:text-[#071427]' : 'text-muted hover:text-heading',
              'focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary',
            )}
            title={option.label + ' theme'}
          >
            <input
              type="radio"
              name="theme"
              value={option.value}
              checked={active}
              onChange={() => setPreference(option.value)}
              className="sr-only"
            />
            <span aria-hidden="true">{option.glyph}</span>
            <span className="sr-only">{option.label}</span>
          </label>
        );
      })}
    </fieldset>
  );
}
